import keyBy from 'lodash/keyBy';

import {
  CheckmarkOutline,
  HashOutline,
  ListOutline,
  Menu3Outline,
  SmileyOutline,
} from '@lyearn/icons';
import { QuestionTypeEnum } from '@/types/schema';

import ENpsField from './e-nps/Editor';
import ENPSQuestionPlayer from './e-nps/Player';
import LikertField from './likert/Editor';
import LikertQuestionPlayer from './likert/Player';
import MultiSelectField from './multi-select/Editor';
import MultiSelectQuestionPlayer from './multi-select/Player';
import RatingQuestionEditor from './rating/Editor';
import RatingQuestionPlayer from './rating/Player';
import SingleSelectField from './single-select/Editor';
import SingleSelectQuestionPlayer from './single-select/Player';
import TextField from './text/Editor';
import TextQuestionPlayer from './text/Player';
import { QuestionPlayerProps } from './types';

export const USER_SURVEY_QUESTION_TYPES = [
  {
    Icon: Menu3Outline,
    value: QuestionTypeEnum.Text,
    labelKey: 'UserSurvey:QuestionTypes.Text',
  },
  {
    Icon: CheckmarkOutline,
    value: QuestionTypeEnum.SingleSelect,
    labelKey: 'UserSurvey:QuestionTypes.Select',
  },
  {
    Icon: ListOutline,
    value: QuestionTypeEnum.MultiSelect,
    labelKey: 'UserSurvey:QuestionTypes.MultiSelect',
  },
  {
    Icon: HashOutline,
    value: QuestionTypeEnum.Enps,
    labelKey: 'UserSurvey:QuestionTypes.eNPS',
  },
  {
    Icon: SmileyOutline,
    value: QuestionTypeEnum.Likert,
    labelKey: 'UserSurvey:QuestionSettings.RatingScale',
  },
];

export const USER_SURVEY_SINGLE_SELECT_OR_MULTISELECT = [
  {
    Icon: CheckmarkOutline,
    value: QuestionTypeEnum.SingleSelect,
    labelKey: 'UserSurvey:QuestionTypes.Select',
  },
  {
    Icon: ListOutline,
    value: QuestionTypeEnum.MultiSelect,
    labelKey: 'UserSurvey:QuestionTypes.MultiSelect',
  },
];

const ALL_EDITOR_FIELDS = [
  TextField,
  SingleSelectField,
  MultiSelectField,
  ENpsField,
  LikertField,
  RatingQuestionEditor,
];

export const UserQuestionsEditorConfig = keyBy(ALL_EDITOR_FIELDS, 'type');

export const USER_SURVEY_QUESTION_PLAYER_CONFIG: Partial<
  Record<QuestionTypeEnum, React.FC<QuestionPlayerProps>>
> = {
  [QuestionTypeEnum.Enps]: ENPSQuestionPlayer,
  [QuestionTypeEnum.Likert]: LikertQuestionPlayer,
  [QuestionTypeEnum.MultiSelect]: MultiSelectQuestionPlayer,
  [QuestionTypeEnum.SingleSelect]: SingleSelectQuestionPlayer,
  [QuestionTypeEnum.Text]: TextQuestionPlayer,
  [QuestionTypeEnum.Rating]: RatingQuestionPlayer,
};
